module.exports = __webpack_public_path__ + "img/ctrl-p-stub-up-0.d28e88d5.svg";